export const landingConstants = {
  LANDINGPAGE_SELECTED: "LANDINGPAGE_SELECTED",
};
